import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { DATASETS_ROUTES } from '../constants/routes.constants'

import { appLayoutRoute } from '@/core/router/layouts'

const datasetsListRoute = createRoute({
  path: DATASETS_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.DatasetsListPage }))
  ),
})

const datasetDetailRoute = createRoute({
  path: DATASETS_ROUTES.DETAIL,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.DatasetDetailPage }))
  ),
})

const datasetsRoutes = [datasetsListRoute, datasetDetailRoute]

export default datasetsRoutes
